import { AbstractEntity } from "../AbstractEntity";
export default class LogbookKeptAdditionally extends AbstractEntity {
    logbookTitle;
    constructor(logbookTitle) {
        super();
        this.logbookTitle = logbookTitle;
    }
}
//# sourceMappingURL=LogbookKeptAdditionally.js.map